/* FlexFit Uniforms — theme behaviour. No dependencies. */
(function () {
  'use strict';

  var scrim = document.querySelector('[data-scrim]');

  function close(el) {
    if (!el) return;
    el.setAttribute('data-open', 'false');
    if (!document.querySelector('[data-open="true"]') && scrim) {
      scrim.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
    }
  }

  function open(el) {
    if (!el) return;
    document.querySelectorAll('[data-open="true"]').forEach(function (o) {
      o.setAttribute('data-open', 'false');
    });
    el.setAttribute('data-open', 'true');
    // The size-guide modal paints its own backdrop
    if (scrim && !el.classList.contains('modal')) scrim.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    var input = el.querySelector('input[type="search"]');
    if (input) setTimeout(function () { input.focus(); }, 350);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-target]');
    if (opener) {
      e.preventDefault();
      open(document.querySelector(opener.getAttribute('data-open-target')));
      return;
    }
    if (e.target.closest('[data-close]') || e.target.hasAttribute('data-scrim')) {
      document.querySelectorAll('[data-open="true"]').forEach(close);
      return;
    }
    // Clicking the modal backdrop closes it
    var modal = e.target.closest('.modal');
    if (modal && !e.target.closest('.modal__box')) close(modal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('[data-open="true"]').forEach(close);
  });

  /* Option buttons (colour / size) ------------------------------------- */
  document.querySelectorAll('[data-option-group]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('[aria-pressed]');
      if (!btn || btn.disabled) return;
      group.querySelectorAll('[aria-pressed]').forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
      });
      btn.setAttribute('aria-pressed', 'true');
      var label = group.parentElement.querySelector('[data-option-value]');
      if (label) label.textContent = btn.getAttribute('data-value') || btn.textContent.trim();
    });
  });

  /* Gallery ------------------------------------------------------------- */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var counter = gallery.querySelector('[data-gallery-count]');
    var strip = gallery.querySelector('[data-thumbs]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-full') || thumb.src;
        main.srcset = '';
        main.alt = thumb.alt;
        thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
        if (counter) counter.textContent = (i + 1) + ' / ' + thumbs.length;
      });
    });

    var prev = gallery.querySelector('[data-thumbs-prev]');
    var next = gallery.querySelector('[data-thumbs-next]');

    function step(dir) {
      if (!strip) return;
      strip.scrollBy({ left: dir * strip.clientWidth * 0.8, behavior: 'smooth' });
    }
    function refreshArrows() {
      if (!strip || !prev || !next) return;
      var max = strip.scrollWidth - strip.clientWidth - 2;
      prev.disabled = strip.scrollLeft <= 2;
      next.disabled = strip.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    if (strip) {
      strip.addEventListener('scroll', refreshArrows, { passive: true });
      window.addEventListener('resize', refreshArrows);
      refreshArrows();
    }
  }

  /* Quantity ------------------------------------------------------------ */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.addEventListener('click', function (e) {
      var step = e.target.closest('[data-step]');
      if (!step) return;
      var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-step'), 10);
      input.value = Math.max(1, next);
    });
  });

  /* Cart: quantity typed straight into a line submits the form ---------- */
  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-line-input]')) form.submit();
    });
  });


  /* Cart: remove or re-quantify a whole Globo group in one request -------- */
  function updateLines(map) {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: map })
    }).then(function () { window.location.reload(); });
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-group-remove]');
    if (remove) {
      var keys = remove.getAttribute('data-group-remove').split(',').filter(Boolean);
      if (keys.length < 2) return; // single line, let the plain link handle it
      e.preventDefault();
      var map = {};
      keys.forEach(function (k) { map[k] = 0; });
      updateLines(map);
      return;
    }

    var step = e.target.closest('[data-group-qty]');
    if (step) {
      var wrap = step.closest('[data-group-keys]');
      if (!wrap) return;
      var groupKeys = wrap.getAttribute('data-group-keys').split(',').filter(Boolean);
      if (groupKeys.length < 2) return;
      e.preventDefault();
      var qty = parseInt(step.getAttribute('data-group-qty'), 10);
      var m = {};
      groupKeys.forEach(function (k) { m[k] = Math.max(0, qty); });
      updateLines(m);
    }
  });

  /* Collection: filters submit on change, one open at a time -------------- */
  var facets = document.querySelector('[data-facets]');
  if (facets) {
    facets.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"], select')) facets.submit();
    });

    document.addEventListener('click', function (e) {
      var panel = e.target.closest('[data-filter]');
      document.querySelectorAll('[data-filter][open]').forEach(function (d) {
        if (d !== panel) d.removeAttribute('open');
      });
    });
  }

  /* Collection: grid density -------------------------------------------- */
  var grid = document.querySelector('[data-products]');
  if (grid) {
    var saved = null;
    try { saved = localStorage.getItem('ff-density'); } catch (err) {}
    if (saved) grid.setAttribute('data-density', saved);

    document.querySelectorAll('[data-density]').forEach(function (btn) {
      if (!btn.matches('button')) return;
      var mode = btn.getAttribute('data-density');
      btn.setAttribute('aria-pressed', String(mode === grid.getAttribute('data-density')));
      btn.addEventListener('click', function () {
        grid.setAttribute('data-density', mode);
        try { localStorage.setItem('ff-density', mode); } catch (err) {}
        document.querySelectorAll('.density__btn').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === btn));
        });
      });
    });
  }

  /* Scroll reveal ------------------------------------------------------- */
  var reveals = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }
})();
